<template>
  <!-- Card View (Vertical) -->
  <div v-if="viewMode === 'card'" id="educationCard">
    <div class="course-path-card mb-2 cursor-pointer"
         @click="bottomTitle !== 'İzlenemez' ? $emit('onClickCard', id) : null">
      <img :src="image" alt="">
      <div class="course-path-card-contents">
        <div class="course-card-info d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center gap-2 flex-wrap">
            <span class="catagroy">{{ subTitle }}</span>
            <span v-if="repeatable == 1" class="order d-block">{{ orderNumber }}. {{$t('general.repeating')}}</span>
          </div>
          <div class="d-flex align-items-center gap-2">
            <span v-if="shouldShowActionLabel" :class="getActionLabelClass()" class="action-label-badge">
              {{ getActionLabelText() }}
            </span>
            <div v-if="gift" class="ml-auto">
              <i aria-expanded="false" class="icon-feather-gift" title=""
                 uk-tooltip="title: Hediyeli Eğitim; pos: bottom-center"></i>
            </div>
            <div>
              <i v-if="hasPresent" class="icon-feather-gift" uk-tooltip="title: Hediyeli Eğitim; pos: bottom-center"></i>
            </div>
          </div>
        </div>
        <div class="assignment-name"> {{ title }} </div>
        <a v-if="isNewAssignedEdu" :class="bottomClass" class="btn btn-success btn-sm text-white card-action-btn" type="button">
          <i :class="iconClass"></i> {{$t('general.start')}}
        </a>
        <a v-else-if="isContinueEdu" :class="bottomClass" class="btn btn-warning btn-sm text-white card-action-btn" type="button">
          <i :class="iconClass"></i> {{$t('general.on_going')}}
        </a>
        <a v-else-if="isDoneEdu" :class="bottomClass" class="btn btn-secondary btn-sm text-secondary card-action-btn"
           type="button">
          <i :class="iconClass"></i> {{$t('general.completed')}}
        </a>
        <a v-else-if="isRepeatEdu" :class="bottomClass" class="btn btn-info btn-sm text-white card-action-btn" type="button">
          <i :class="iconClass"></i> {{$t('general.repeat')}}
        </a>
        <a v-else :class="bottomClass" class="btn btn-success btn-sm text-white card-action-btn" type="button">
          <i :class="iconClass"></i> {{ bottomTitle }}
        </a>
        <div :uk-tooltip="'title:%' +
          processWidth +
          ' ' +
          $t('education.Completed') +
          '; pos: top-center'
          " class="course-progressbar mt-1">
          <div :class="processClass" :style="{ width: processWidth + '%' }" class="course-progressbar-filler"></div>
        </div>

        <div class="mt-1">
          <p class="date d-flex align-items-center"><i class="icon-feather-calendar mr-1"></i>{{ time }}</p>
        </div>
      </div>
      <div v-if="hasRating" class="course-path-card-footer">
        <div class="star-rating" :aria-label="`Rating: ${normalizedRate} / 5`">
          <span class="avg">{{ normalizedRate }}</span>
          <span v-for="star in 5" :key="`rating-star-${star}`" :class="['star', starClass(star)]"></span>
        </div>
      </div>
    </div>
  </div>

  <!-- List View (Horizontal) -->
  <div v-else class="mode-list">
    <div class="course-path-card-list mb-3 cursor-pointer" @click="$emit('onClickCard', id)">
      <div class="course-list-image">
        <img :src="image" alt="" class="course-image">
      </div>
      <div class="course-list-content">
        <div class="course-list-header">
          <div class="course-list-meta">
            <span class="catagroy">{{ subTitle }}</span>
            <span class="order" v-if="repeatable === 1">{{ orderNumber }}. {{$t('general.repeating')}}</span>
          </div>
          <div class="course-list-header-right">
            <span v-if="shouldShowActionLabel" :class="getActionLabelClass()" class="action-label-badge">
              {{ getActionLabelText() }}
            </span>
            <div class="course-list-time">
              <i class="icon-feather-calendar"></i>
              <span>{{ time }}</span>
            </div>
            <div class="course-list-icons">
              <i v-if="hasPresent" class="icon-feather-gift" uk-tooltip="title: Hediyeli Eğitim; pos: bottom-center"></i>
            </div>
          </div>
        </div>
        <h3 class="assignment-name">{{ title }}</h3>
        <div class="course-list-actions">
          <a v-if="isNewAssignedEdu" :class="bottomClass" class="btn btn-success btn-sm text-white"
            type="button">
            <i :class="iconClass"></i> {{$t('general.start')}}
          </a>
          <a v-else-if="isContinueEdu" :class="bottomClass" class="btn btn-warning btn-sm text-white"
            type="button">
            <i :class="iconClass"></i> {{$t('general.on_going')}}
          </a>
          <a v-else-if="isDoneEdu" :class="bottomClass" class="btn btn-secondary btn-sm text-secondary"
            type="button">
            <i :class="iconClass"></i> {{$t('general.completed')}}
          </a>
          <a v-else-if="isRepeatEdu" :class="bottomClass" class="btn btn-info btn-sm text-white"
            type="button">
            <i :class="iconClass"></i> {{$t('general.repeat')}}
          </a>
          <a v-else-if="isAssignmentEndDateExpired" :class="bottomClass" class="btn btn-secondary btn-sm text-secondary"
            type="button"
            uk-tooltip="title: $t('general.training_deadline_passed'); pos: bottom-center">
            <i :class="iconClass"></i> {{ bottomTitle }}
          </a>
          <a v-else :class="bottomClass" class="btn btn-success btn-sm text-white"
            type="button">
            <i :class="iconClass"></i> {{ bottomTitle }}
          </a>
        </div>
        <div class="course-progressbar mt-2" :uk-tooltip="'title:%' +
          processWidth +
          ' ' +
          $t('education.Completed') +
          '; pos: top-center'
          ">
          <div :class="processClass" :style="{ width: processWidth + '%' }" class="course-progressbar-filler"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'educationCard',
  props: {
    id: {
      required: false,
      default: 1,
    },
    eduItem: {
      type: Object,
      default: () => {
      },
    },
    repeatable: {
      required: false,
      default: 0,
    },
    orderNumber: {
      required: false,
      default: 0,
    },
    title: {
      required: true,
    },
    subTitle: {
      required: true,
    },
    bottomTitle: {
      required: true,
    },
    links: {
      required: true,
    },
    time: {
      required: true,
    },
    image: {
      required: true,
    },
    bottomClass: {
      required: true,
    },
    processWidth: {
      required: true,
    },
    processClass: {
      default: '',
      required: false,
    },
    iconClass: {
      required: true,
    },
    hasPresent: {
      required: true,
    },
    rate: {
      required: false,
    },
    gift: {
      required: false,
    },
    isAssignmentEndDateExpired: {
      required: false,
      default: false,
    },
    isWatchableAgain: {
      required: false,
    },
    viewMode: {
      type: String,
      default: 'card',
      validator: (value) => ['card', 'list'].includes(value)
    },
    actionLabel: {
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {
    isNewAssignedEdu() {
      return (
          (!this.eduItem.completed_contents || this.eduItem.completed_contents.length === 0) &&
          this.eduItem.completion_percentage === 0 &&
          !this.eduItem.is_completed &&
          !this.eduItem.assignment_user_started_at
      )
    },
    isContinueEdu() {
      return (
          !this.eduItem.is_completed &&
          this.eduItem.completion_percentage < 100 &&
          (
            (this.eduItem.completed_contents?.length > 0 && this.eduItem.completion_percentage > 0) ||
            !!this.eduItem.assignment_user_started_at
          )
      );
    },
    isDoneEdu() {
      return (
          this.eduItem.completion_percentage >= 100 ||
          !!this.eduItem.is_completed
      );
    },
    isRepeatEdu() {
      return this.eduItem.repeatable === true;
    },
    shouldShowActionLabel() {
      if (!this.actionLabel) return false;

      // Butonla aynı bilgiyi gösteriyorsa badge'i gizle
      const redundantLabels = ['start', 'continue', 'completed', 'watchagain'];

      // Eğer action_label butonla eşleşiyorsa gösterme
      if (redundantLabels.includes(this.actionLabel)) {
        return false;
      }

      // not_started ve expired gibi farklı bilgiler için göster
      return true;
    },
    normalizedRate() {
      const value = Number(this.rate);
      return Number.isFinite(value) ? Math.max(0, Math.min(5, value)) : 0;
    },
    hasRating() {
      return this.rate !== null && this.rate !== undefined && this.rate !== '' && Number.isFinite(Number(this.rate));
    }

  },
  methods: {
    getActionLabelClass() {
      const labelClasses = {
        'not_started': 'badge-info',
        'start': 'badge-success',
        'continue': 'badge-warning',
        'expired': 'badge-danger',
        'watchagain': 'badge-info',
        'completed': 'badge-secondary'
      };
      return labelClasses[this.actionLabel] || 'badge-secondary';
    },
    getActionLabelText() {
      const labelTexts = {
        'not_started': this.$t('general.not_started') || 'Başlamadı',
        'start': this.$t('general.start') || 'Başlat',
        'continue': this.$t('general.continue') || 'Devam Et',
        'expired': this.$t('general.expired') || 'Süresi Doldu',
        'watchagain': this.$t('general.watch_again') || 'Tekrar İzle',
        'completed': this.$t('general.completed') || 'Tamamlandı'
      };
      return labelTexts[this.actionLabel] || this.actionLabel;
    },
    starClass(star) {
      if (this.normalizedRate >= star) return '';
      if (this.normalizedRate >= star - 0.5) return 'half';
      return 'empty';
    }
  }
}
</script>
<style scoped>
.cursor-pointer {
  cursor: pointer;
}

/* Card View Styles — tıklanabilir: border yok, soft shadow */
#educationCard .course-path-card {
  border: none !important;
  border-radius: 14px !important;
  overflow: hidden !important;
  background: #fff !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;
  height: 100% !important;
  display: flex !important;
  flex-direction: column !important;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease !important;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
}

#educationCard .course-path-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12) !important;
}

#educationCard .course-path-card:active {
  transform: scale(0.98);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;
}

#educationCard .course-path-card img {
  width: 100% !important;
  aspect-ratio: 16/9;
  object-fit: cover !important;
  display: block !important;
}

#educationCard .course-path-card-contents {
  padding: 14px !important;
  flex: 1 !important;
  display: flex !important;
  flex-direction: column !important;
  background: #fff !important;
}

.assignment-name {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  font-size: 0.85rem;
  margin-bottom: 4px;
  font-weight: 600;
  color: #333;
  line-height: 1.4;
}

/* Butonlar - içerik kadar genişlik, sola yaslı */
.card-action-btn {
  display: inline-flex !important;
  align-items: center;
  gap: 4px;
  width: fit-content !important;
  max-width: fit-content !important;
  margin-bottom: 0 !important;
}

.card-action-btn i {
  margin-right: 0;
}

.order {
  font-size: 13px;
  font-weight: bold;
}

/* Action Label Badge Styles */
.action-label-badge {
  display: inline-block;
  font-size: 11px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 12px;
  line-height: 1.2;
  white-space: nowrap;
}

.badge-info {
  background-color: #17a2b8;
  color: white;
}

.badge-success {
  background-color: #28a745;
  color: white;
}

.badge-warning {
  background-color: #ffc107;
  color: #212529;
}

.badge-danger {
  background-color: #dc3545;
  color: white;
}

.badge-secondary {
  background-color: #6c757d;
  color: white;
}

.gap-2 {
  gap: 8px;
}

/* List View Styles — tıklanabilir: border yok, soft shadow */
.course-path-card-list {
  display: flex;
  align-items: stretch;
  background: white;
  border: none;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
}

.course-path-card-list:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  transform: translateY(-2px);
}

.course-path-card-list:active {
  transform: scale(0.98);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.course-list-image {
  flex: 0 0 280px;
  min-width: 280px;
  overflow: hidden;
  background: #f5f5f5;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.course-image {
  width: 100%;
  height: 150px;
  object-fit: cover;
  object-position: left center;
  display: block;
}

.course-list-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 20px;
  min-width: 0;
  position: relative;
}

.course-list-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
}

.course-list-header-right {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.course-list-meta {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.course-list-icons {
  display: flex;
  align-items: center;
  gap: 8px;
}

.course-list-icons i {
  color: #ffab00;
  font-size: 1.1rem;
}

.course-list-time {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #666;
  font-size: 14px;
  white-space: nowrap;
}

.course-list-time i {
  font-size: 14px;
  color: #999;
}

.course-list-content .assignment-name {
  font-size: 1.125rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-word;
  white-space: normal;
  text-transform: none;
}

.course-list-actions {
  margin-bottom: 0;
}

.course-list-actions .btn {
  margin-right: 8px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

/* Tablet — List View */
@media (max-width: 960px) {
  .course-path-card-list {
    flex-direction: column;
    border-radius: 14px;
    /* Remove box-shadow transition on mobile */
    transition: transform 0.15s ease;
    will-change: transform;
  }

  /* Disable hover on touch */
  .course-path-card-list:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    transform: none;
  }

  .course-path-card-list:active {
    transform: scale(0.98);
  }

  .course-list-image {
    flex: 0 0 auto;
    width: 100%;
    min-width: 100%;
    height: 150px;
  }

  .course-image {
    height: 150px;
  }

  .course-list-content {
    padding: 16px;
  }

  .course-list-actions .btn {
    min-height: 40px;
    font-size: 12px;
    padding: 8px 12px;
    border-radius: 10px;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
  }

  .course-list-actions .btn:active {
    opacity: 0.85;
  }
}

/* Mobile — List View */
@media (max-width: 640px) {
  .course-list-image {
    height: 140px;
  }

  .course-image {
    height: 140px;
  }

  .course-list-content {
    padding: 12px;
  }

  .course-list-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .course-list-header-right {
    width: 100%;
    justify-content: space-between;
  }

  .course-list-content .assignment-name {
    font-size: 14px;
    -webkit-line-clamp: 3;
    line-clamp: 3;
  }

  .course-list-time {
    font-size: 12px;
  }

  .course-list-time i {
    font-size: 12px;
  }
}

/* Tablet — Card View */
@media (max-width: 960px) {
  #educationCard .course-path-card {
    border-radius: 14px !important;
    /* Remove box-shadow transition on mobile — saves paint operations */
    transition: transform 0.15s ease !important;
    will-change: transform;
  }

  /* Disable hover on touch */
  #educationCard .course-path-card:hover {
    transform: none;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;
  }

  /* Active state for touch feedback */
  #educationCard .course-path-card:active {
    transform: scale(0.98);
  }

  /* Disable uk-tooltip on mobile (no hover, wastes JS listeners) */
  #educationCard [uk-tooltip] {
    pointer-events: auto;
  }
}

/* Mobile — Card View */
@media (max-width: 768px) {
  #educationCard .course-path-card {
    border-radius: 14px !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;
  }

  #educationCard .course-path-card-contents {
    padding: 10px !important;
  }

  #educationCard .assignment-name {
    font-size: 13px !important;
    line-height: 1.4 !important;
    margin-bottom: 8px !important;
    -webkit-line-clamp: 2;
    max-height: calc(13px * 1.4 * 2);
  }

  #educationCard .course-card-info .catagroy {
    font-size: 12px !important;
  }

  #educationCard .course-card-info .order {
    font-size: 12px !important;
  }

  #educationCard .course-path-card .btn {
    font-size: 12px !important;
    padding: 6px 10px !important;
    min-height: 32px;
    border-radius: 8px;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
  }

  #educationCard .course-path-card .btn:active {
    opacity: 0.85;
  }

  #educationCard .course-progressbar {
    height: 5px !important;
    margin-top: 8px !important;
  }

  #educationCard .date {
    font-size: 12px !important;
    margin-top: 6px !important;
  }

  #educationCard .date i {
    font-size: 12px !important;
  }

  #educationCard .icon-feather-gift {
    font-size: 13px !important;
  }
}

/* Small Mobile — Card View */
@media (max-width: 480px) {
  #educationCard .course-path-card {
    border-radius: 14px !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;
  }

  #educationCard .course-path-card-contents {
    padding: 8px !important;
  }

  #educationCard .assignment-name {
    font-size: 12px !important;
    line-height: 1.4 !important;
    margin-bottom: 4px !important;
    max-height: calc(12px * 1.4 * 2);
  }

  #educationCard .course-card-info .catagroy,
  #educationCard .course-card-info .order {
    font-size: 12px !important;
  }

  #educationCard .course-path-card .btn {
    font-size: 12px !important;
    padding: 4px 8px !important;
    min-height: 28px;
    border-radius: 8px;
  }

  #educationCard .course-progressbar {
    height: 4px !important;
    margin-top: 6px !important;
  }

  #educationCard .date {
    font-size: 12px !important;
    margin-top: 4px !important;
  }

  #educationCard .date i {
    font-size: 12px !important;
  }

  #educationCard .icon-feather-gift {
    font-size: 12px !important;
  }
}
</style>
